import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const CrewListContainerStyled = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  ul {
    margin-left: ${({ theme }) => theme.spacings['600']};
  }
`;
export const CrewListItemStyled = styled.li`
  position: relative;
  margin-left: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: ${({ theme }) => theme.spacings['500']};

  &:last-child:before {
    position: absolute;
    top: 0;
    left: -14px;
    height: 40px; /* vertical position of line */
    vertical-align: top;
    content: '';
    display: inline-block;
    color: ${({ theme }) => theme.colors.grey['300']};
    border-left: 1px solid ${({ theme }) => theme.colors.grey['300']};
    z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
  }

  &:not(:last-child):before {
    position: absolute;
    top: 0;
    left: -14px;
    height: 100%; /* vertical position of line */
    vertical-align: top;
    content: '';
    display: inline-block;
    color: ${({ theme }) => theme.colors.grey['300']};
    border-left: 1px solid ${({ theme }) => theme.colors.grey['300']};
    z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
  }
`;
export const CrewBulletStyled = styled.div`
  position: absolute;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.grey['300']};
  left: -18px;
  top: 30px;
  z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
`;

export const ErrorContainer = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  py: { sm: '900' },
  flexGrow: { sm: 1 },
})`
  height: 100%;
  /* ErrorRetry control not to expand full width of screen */
  & > :first-child {
    flex-grow: 0 !important;
  }
`;
